<p-confirmDialog [style]="{ width: '26rem' }"></p-confirmDialog>
<section class="ata-tela">
    <form [formGroup]="formularioAta" class="ata-layout">
        <!-- ═══ ESQUERDA — identidade da ata + painel (membros/convidados/atividades) ═══ -->
        <div class="ata-coluna-lateral">
            <app-card-content [border]="false" headingLevel="h1" icon="pi pi-file-edit" [title]="tituloReuniao" [subtitle]="'Protocolo ' + protocoloReuniao">
                <div card-header>
                    <button type="button" pButton label="Voltar" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" size="small" (click)="voltarParaAcompanhamento()"></button>
                </div>

                <div class="bloco-assistente">
                    <label class="rotulo-assistente" for="selectAssistenteAta">Assistente</label>
                    <p-select
                        inputId="selectAssistenteAta"
                        class="w-full"
                        formControlName="assistente"
                        [options]="assistentesDisponiveis"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Selecionar"
                        [showClear]="false"
                        [appCan]="roleDesignarAssistente"
                        (onChange)="aoAlterarAssistente()"
                        appendTo="body"
                    >
                        <ng-template pTemplate="selectedItem" let-op>
                            @if (op) {
                                <div class="opcao-pessoa">
                                    <app-pessoa-avatar [idSolicitante]="idDaChavePessoa(op.value)" [uf]="ufDaChavePessoa(op.value)" [nome]="op.label" tamanho="sm"></app-pessoa-avatar>
                                    <span class="opcao-pessoa-nome">{{ op.label }}</span>
                                </div>
                            }
                        </ng-template>
                        <ng-template pTemplate="item" let-op>
                            <div class="opcao-pessoa">
                                <app-pessoa-avatar [idSolicitante]="idDaChavePessoa(op.value)" [uf]="ufDaChavePessoa(op.value)" [nome]="op.label" tamanho="sm"></app-pessoa-avatar>
                                <span class="opcao-pessoa-nome">{{ op.label }}</span>
                            </div>
                        </ng-template>
                    </p-select>
                </div>

                <div class="legenda-presenca legenda-presenca--centralizada">
                    @for (item of legendaPresenca; track item.label) {
                        <span class="item-legenda">
                            <i [class]="iconeSituacao(item.situacao)" [ngClass]="classeSituacao(item.situacao)"></i>
                            {{ item.label }}
                        </span>
                    }
                </div>
                <div class="acoes-identidade">
                    <button type="button" pButton label="Gestores" icon="pi pi-users" severity="secondary" [outlined]="true" [disabled]="!permiteAlteracao" [appCan]="roleGerenciarConvidados" (click)="abrirDialogGestores()"></button>
                    <button type="button" pButton label="Importante" icon="pi pi-star" severity="warn" [disabled]="!permiteAlteracao" [outlined]="!ataImportante" [appCan]="roleAtasEditar" (click)="abrirDialogImportante()"></button>
                    <button type="button" pButton label="Salvar" icon="pi pi-save" [disabled]="!permiteAlteracao" [appCan]="roleAtasEditar" (click)="salvarAta()"></button>
                </div>
            </app-card-content>

            <app-card-content [border]="false" icon="pi pi-users" title="Membros" subtitle="Presença dos membros">
                <div card-header>
                    <button
                        type="button"
                        pButton
                        label="Inserir Todos"
                        icon="pi pi-list-check"
                        severity="secondary"
                        [outlined]="true"
                        size="small"
                        [disabled]="!permiteAlteracao"
                        [appCan]="roleGerenciarConvidados"
                        (click)="inserirTodosParticipantesNaAta()"
                    ></button>
                </div>
                <app-ata-tabela-participantes
                    [plano]="true"
                    rotuloColuna="Membro"
                    tipo="M"
                    [participantes]="membros()"
                    [permiteAlteracao]="permiteAlteracao"
                    scrollHeight="15rem"
                    [mostrarAvatar]="true"
                    tamanhoAvatar="xl"
                    (inserirNaAta)="inserirParticipanteNaAta($event, 'M')"
                    (alterarPresenca)="abrirDialogPresenca($event, 'M')"
                ></app-ata-tabela-participantes>
            </app-card-content>

            <app-card-content [border]="false" icon="pi pi-user-plus" title="Convidados" subtitle="Convidados da reunião">
                <div card-header>
                    <button type="button" pButton label="Adicionar" icon="pi pi-plus" severity="secondary" [outlined]="true" size="small" [disabled]="!permiteAlteracao" [appCan]="roleGerenciarConvidados" (click)="abrirDialogConvidado()"></button>
                </div>
                <app-ata-tabela-participantes
                    [plano]="true"
                    rotuloColuna="Convidado"
                    tipo="C"
                    [participantes]="convidados()"
                    [permiteAlteracao]="permiteAlteracao"
                    scrollHeight="15rem"
                    [permiteRemover]="true"
                    [mostrarAvatar]="true"
                    tamanhoAvatar="xl"
                    (inserirNaAta)="inserirParticipanteNaAta($event, 'C')"
                    (alterarPresenca)="abrirDialogPresenca($event, 'C')"
                    (remover)="removerConvidado($event.participante, $event.event)"
                ></app-ata-tabela-participantes>
            </app-card-content>

            <app-card-content [border]="false" icon="pi pi-list-check" title="Atividades" subtitle="Tarefas da reunião">
                <div card-header>
                    <button type="button" pButton label="Adicionar" icon="pi pi-plus" severity="secondary" [outlined]="true" size="small" [disabled]="!permiteAlteracao" [appCan]="roleAtividadesCriar" (click)="abrirDialogNovaAtividade()"></button>
                </div>
                <app-ata-atividades
                    [plano]="true"
                    [atividades]="atividades()"
                    [atividadeSelecionada]="atividadeSelecionada"
                    [atividadeResolvida]="atividadeResolvida"
                    [permiteAlteracao]="permiteAlteracao"
                    (editar)="abrirDialogEditarAtividade($event)"
                    (excluir)="removerAtividade($event)"
                    (selecionar)="selecionarAtividade($event)"
                    (alternarResolvida)="alternarAtividadeResolvida($event)"
                ></app-ata-atividades>
            </app-card-content>
        </div>

        <!-- ═══ DIREITA — documento da ata (editor + ações) ═══ -->
        <div class="ata-coluna-documento">
            <app-card-content [border]="false" icon="pi pi-pencil" title="Documento da Ata" [subtitle]="permiteAlteracao ? 'Redação da ata da reunião' : 'Somente leitura'">
                <div card-header>
                    <app-botao-acoes label="Opções" [iconColumns]="3" [iconPos]="EInconPos.LEFT" [items]="itensOpcoesDocumento"></app-botao-acoes>
                </div>
                <section class="editor-principal">
                    @if (conflitoAtaMensagem()) {
                        <div class="ata-conflito" role="alert">
                            <span>{{ conflitoAtaMensagem() }}</span>
                            <button type="button" pButton label="Recarregar ata" icon="pi pi-refresh" severity="warn" (click)="solicitarRecarregarAta()"></button>
                        </div>
                    }
                    <p-editor formControlName="conteudoAta" styleClass="editor-ata" [style]="{ height: '100%' }" [readonly]="!permiteAlteracao">
                        <!--
                            Os controles do Quill não trazem rótulo próprio: sem aria-label o leitor
                            de tela anuncia apenas "botão". O type="button" evita que a barra submeta
                            o formulário que envolve o editor.
                        -->
                        <ng-template pTemplate="header">
                            <span class="ql-formats">
                                <select class="ql-font" aria-label="Fonte"></select>
                                <select class="ql-size" aria-label="Tamanho da fonte"></select>
                            </span>
                            <span class="ql-formats">
                                <button type="button" class="ql-bold" aria-label="Negrito" title="Negrito"></button>
                                <button type="button" class="ql-italic" aria-label="Itálico" title="Itálico"></button>
                                <button type="button" class="ql-underline" aria-label="Sublinhado" title="Sublinhado"></button>
                                <button type="button" class="ql-strike" aria-label="Tachado" title="Tachado"></button>
                            </span>
                            <span class="ql-formats">
                                <button type="button" class="ql-list" value="ordered" aria-label="Lista numerada" title="Lista numerada"></button>
                                <button type="button" class="ql-list" value="bullet" aria-label="Lista com marcadores" title="Lista com marcadores"></button>
                                <select class="ql-align" aria-label="Alinhamento"></select>
                            </span>
                            <span class="ql-formats">
                                <button type="button" class="ql-color" aria-label="Cor do texto" title="Cor do texto"></button>
                                <button type="button" class="ql-background" aria-label="Cor de fundo" title="Cor de fundo"></button>
                                <button type="button" class="ql-link" aria-label="Inserir link" title="Inserir link"></button>
                                <button type="button" class="ql-clean" aria-label="Limpar formatação" title="Limpar formatação"></button>
                            </span>
                        </ng-template>
                    </p-editor>
                </section>

                <p-menu #menuModelos [model]="itensModelosAta" [popup]="true" appendTo="body"></p-menu>
            </app-card-content>
        </div>
    </form>
</section>

<app-pesquisar-pessoa-custom [(showDialog)]="pesquisaConvidadoVisivel" (pessoa)="adicionarConvidadoSelecionado($event)"></app-pesquisar-pessoa-custom>

<app-ata-dialog-importante [(visivel)]="exibirDialogImportante" [textoInicial]="textoImportante" (confirmar)="confirmarImportante($event)"></app-ata-dialog-importante>

<app-ata-dialog-gestores [(visivel)]="exibirDialogGestores" [opcoesMembros]="opcoesGestoresMembros" [opcoesAssistentes]="assistentesDisponiveis" [inicial]="gestoresIniciais" (confirmar)="confirmarGestores($event)"></app-ata-dialog-gestores>

<app-ata-preview [(visivel)]="exibirPreviewAta" [documentoHtml]="documentoPreviewHtml" [tipo]="tipoPreview" (selecionarTipo)="selecionarTipoPreview($event)"></app-ata-preview>

<app-ata-dialog-presenca
    [(visivel)]="exibirDialogPresenca"
    [participante]="participanteSelecionado"
    [tipo]="tipoParticipanteSelecionado ?? 'M'"
    [opcoes]="opcoesDialogPresenca"
    [valorInicial]="presencaSelecionada"
    (confirmar)="confirmarAlteracaoPresenca($event)"
></app-ata-dialog-presenca>

<app-ata-dialog-atividade
    [(visivel)]="exibirDialogAtividade"
    [situacoes]="situacoesAtividade()"
    [responsaveis]="responsaveisPossiveis"
    [reuniao]="reuniao()"
    [atividadeEdicao]="atividadeEmEdicao"
    (salvar)="salvarAtividade($event)"
></app-ata-dialog-atividade>
